import React from "react";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import "./styles.css";
import { db } from "../../utils/firebase";
// eslint-disable-next-line no-unused-vars
import { collection, setDoc, addDoc, getDoc, getDocs, query, doc, updateDoc } from "firebase/firestore";
import { useAuth } from "../../contexts/AuthContext";

const schema = Yup.object().shape({
  spent: 0,
  month: Yup.number().required("Month is required"),
  year: Yup.number().required("Year is required"),
  amount: Yup.string()
    .trim()
    .matches(/^\d+(\.\d{1,2})?$/, "Not a valid amount")
    .required("Amount is required"),
  category: Yup.string().required("Category is required"),
});

const AddBudgetPageContent = () => {
  const { id } = useParams();
  let navigate = useNavigate();
  const { currentUser } = useAuth();
  const [dateVal, setDateVal] = useState();
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors = false, isSubmitted },
  } = useForm({
    resolver: yupResolver(schema),
  });

  // eslint-disable-next-line no-unused-vars
  const transactionsCollectionRef = collection(
    db,
    `budgets/${currentUser.auth.currentUser.uid}/budgetDocs/`
  );
  const budgetsCollectionRef = query(
    collection(db, `budgets/${currentUser.auth.currentUser.uid}/budgetDocs`)
  );

  //const [newType, setNewType] = useState("");
  const [editTrans, setEditTrans] = useState(null);

  const createTransaction = async (formValues) => {
    //check if budget set once for current month-year
    const data = await getDocs(budgetsCollectionRef);
    const dataReal = data.docs.map((doc) => ({
      ...doc.data(),
      uId: doc.id,
      budgetDocs: doc.data().budgetDocs,
    }));

    var yearMonthBudget = dataReal.filter(
      (bud) =>
        bud.uId ===
        formValues.year +
          (formValues.month < 10
            ? "0" + formValues.month.toString()
            : formValues.month.toString())
    );
    console.log("yearMonthBudget");
    console.log(yearMonthBudget);

    if (yearMonthBudget.length) {
      // console.log("Previously set");
      await updateDoc(
        doc(
          db,
          `budgets/${currentUser.auth.currentUser.uid}/budgetDocs/`,
          `${
            new Date().getFullYear() +
            (formValues.month < 10
              ? "0" + formValues.month.toString()
              : formValues.month.toString())
          }`
        ),
        { [formValues.category]: parseFloat(formValues.amount) }
      );
    } else {
      // console.log("First time setting for year and month");

      await setDoc(
        doc(
          db,
          `budgets/${currentUser.auth.currentUser.uid}/budgetDocs/`,
          `${
            new Date().getFullYear() +
            (formValues.month < 10
              ? "0" + formValues.month.toString()
              : formValues.month.toString())
          }`
        ),
        { [formValues.category]: parseFloat(formValues.amount) }
      );
    }

    navigate("/budget");
  };

  const getTransactionById = async () => {
    const transactionByIdCollectionRef = doc(
      db,
      `budgets/${currentUser.auth.currentUser.uid}/budgetDocs/`,
      id
    );
    try {
      const docSnap = await getDoc(transactionByIdCollectionRef);
      console.log(docSnap.data());
      if (docSnap.exists()) {
        setEditTrans(docSnap.data());
        // set the year, month in the format yyyy-mm
        //setValue("date", docSnap.data().date);
        setValue("amount", docSnap.data().amount);
        setValue("category", docSnap.data().category);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const editTransaction = async (formValues) => {
    const editTransactionRef = doc(
      db,
      `budgets/${currentUser.auth.currentUser.uid}/budgetDocs/`,
      id
    );
    try {
      const docSnap = await getDoc(editTransactionRef);
      console.log(docSnap.data());
      if (docSnap.exists()) {
        await updateDoc(editTransactionRef, {
          category: parseFloat(formValues.amount).toFixed(2),
        });
        navigate(`/budgets/${currentUser.auth.currentUser.uid}/budgetDocs/`);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (id) {
      getTransactionById();
    } else {
      reset();
      //set the default form date to the current date
      var dateVal = new Date().toLocaleDateString("en-US").split("T")[0];
      var formattedDate = dateVal.split("/")[2];
      //.replace(/^(\d{4})-(\d{2})-(\d{2})$/, "$1-$2-$3");

      setDateVal(formattedDate);
      setValue("date", formattedDate);
    }
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit = (formValues) => {
    console.log(formValues);
    if (id) {
      editTransaction(formValues);
    } else {
      createTransaction(formValues);
    }
  };

  return (
    <div className="formBody">
      <div className="row">
        <div className="col-md-6 text-left">
          {id ? (
            <>
              <h1>Edit Budget</h1>
              <br />
            </>
          ) : (
            <>
                <h1>Add Budget</h1>
                <p><em>Input budget details to successfully add it.</em></p>
              <br />
            </>
          )}
        </div>
      </div>
      <div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form-row">
            <div className="form-group col-md-6">
              <label>
                Month: (MM)<span className="required">*</span>
                <select
                  className={
                    errors?.category?.message && isSubmitted
                      ? "form-select error"
                      : "form-select"
                  }
                  {...register("month", { required: true })}
                  defaultValue={new Date().getMonth() + 1}
                >
                  <option value="01" label="January"></option>
                  <option value="02" label="February"></option>
                  <option value="03" label="March"></option>
                  <option value="04" label="April"></option>
                  <option value="05" label="May"></option>
                  <option value="06" label="June"></option>
                  <option value="07" label="July"></option>
                  <option value="08" label="August"></option>
                  <option value="09" label="September"></option>
                  <option value="10" label="October"></option>
                  <option value="11" label="November"></option>
                  <option value="12" label="December"></option>
                </select>
              </label>
              {errors?.category?.message && isSubmitted && (
                <span className="error-message">
                  {errors?.category?.message}
                </span>
              )}
              <br />
              <label>
                Year: (YYYY)<span className="required">*</span>
                <input
                  type="text"
                  id="Year"
                  label="Year"
                  className={
                    errors?.amount?.message && isSubmitted
                      ? "form-control error"
                      : "form-control"
                  }
                  defaultValue={dateVal}
                  {...register("year")}
                />
              </label>
            </div>

            <div className="form-group col-md-6"></div>
          </div>
          <div className="form-row">
            <div className="form-group col-md-6">
              <label>
                Amount<span className="required">*</span>
                <input
                  id="Amount"
                  className={
                    errors?.amount?.message && isSubmitted
                      ? "form-control error"
                      : "form-control"
                  }
                  {...register("amount")}
                />
                <span className="error">{errors?.amount?.message}</span>
              </label>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group col-md-6">
              <label>
                Category<span className="required">*</span>
              </label>
              <br />
              <label>
                <select
                  id="Category"
                  className={
                    errors?.category?.message && isSubmitted
                      ? "form-select error"
                      : "form-select"
                  }
                  {...register("category")}
                >
                  <option value=""></option>
                  <option value="Donation">Donation</option>
                  <option value="Education">Education</option>
                  <option value="Entertainment">Entertainment</option>
                  <option value="Groceries">Groceries</option>
                  <option value="Housing">Housing</option>
                  <option value="Medical">Medical</option>
                  <option value="Other Expense">Other Expense</option>
                  <option value="Pets">Pets</option>
                  <option value="Restaurant">Restaurant</option>
                  <option value="Technology">Technology</option>
                  <option value="Utilities">Utilities</option>
                  <option value="Vacation">Vacation</option>
                  <option value="Work">Work</option>
                </select>
              </label>
              <span className="error">{errors?.category?.message}</span>
            </div>
          </div>

          <div>
            <Link to="/budget" className="btn btn-secondary float-right">
              Cancel
            </Link>
            {id && editTrans ? (
              <button
                type="submit"
                className="btn btn-primary float-right mr-2"
              >
                Edit
              </button>
            ) : (
              <button
                type="submit"
                className="btn btn-success float-right mr-2"
              >
                Add
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddBudgetPageContent;
